<template>
  <div class="app-container">
    <list ref="list">
      <template slot="toolbar-right" v-if="$permission.canWrite()">
        <el-button size="mini" type="success" plain @click="inportTeacher" v-if="!isMB">导入</el-button>
        <el-button size="mini" type="primary" plain @click="onExport" v-if="!isMB">导出</el-button>
        <el-button size="mini" type="primary" @click="create">添加</el-button>
        <el-button size="mini" type="danger" @click="delRows">删除</el-button>
      </template>
      <template slot="column" v-if="$permission.canWrite()">
        <el-table-column label="操作" fixed="right" align="center" :width="isMB?60:80">
          <template slot-scope="{row}">
            <el-button type="text" @click="edit(row)" size="medium" icon="el-icon-edit-outline" title="编辑"></el-button>
            <!-- <el-button type="text" v-if="row.IsLogin==1" @click="logout(row)">注销</el-button> -->
          </template>
        </el-table-column>
      </template>
    </list>
    <edit-dialog ref="editDialog" @close-saved="reload" />
    <import-dialog ref="importDialog" @upload-success="reload" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/sys/user/list";
import editDialog from "@/components/sys/user/editDialog";
import importDialog from "@/components/sys/user/importDialog";

export default {
  name: "user",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
    importDialog,
  },
  data() {
    return {
      isMB: this.$store.state.isMB,
    };
  },
  methods: {
    // details(row) {
    //   this.$refs.detailDialog.openDetails(row);
    // },
    // logout(row) {
    //   this.$confirm("确认注销已登录的用户吗？", "提示", {
    //     confirmButtonText: "确定",
    //     cancelButtonText: "取消",
    //     type: "warning",
    //   })
    //     .then(() => {
    //       this.$refs.list.logout(row);
    //     })
    //     .catch(() => {});
    // },
    onExport() {
      this.$refs.list.onExport();
    },
    inportTeacher() {
      this.$refs.importDialog.open();
    },
    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.UserId;
          });
          this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
  },
};
</script>